var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Preact from 'preact';
import * as ActionBar from './M_ActionBar';
import { Undo, Redo } from '@mui/icons-material';
import { isSmallScreen } from './domain/theme/breakpoints';
import { IconButton, lighten, useTheme } from '@mui/material';
export var Component = function (p) {
    var theme = useTheme();
    var isSmall = isSmallScreen(theme);
    return (Preact.h(ActionBar.Component, { sx: __assign(__assign({}, p.sx), { width: isSmall ? '95.422px' : 'auto' }) },
        Preact.h(IconButton, { onClick: p.onUndoClick, size: isSmall ? 'small' : 'medium', color: "secondary", disabled: !p.onUndoClick, sx: {
                borderRadius: isSmall ? '5px' : '8px',
                textTransform: 'none',
                height: isSmall ? 'auto' : '48px',
                width: isSmall ? '42px' : 'auto',
                padding: isSmall ? '5px' : '12px',
                fontSize: 'medium',
                '&:hover': {
                    backgroundColor: lighten(theme.palette.primary.main, 0.9),
                    color: theme.palette.primary.main,
                    borderColor: theme.palette.primary.main,
                },
            } },
            Preact.h(Undo, { fontSize: "medium" })),
        Preact.h(IconButton, { onClick: p.onRedoClick, size: isSmall ? 'small' : 'medium', color: "secondary", disabled: !p.onRedoClick, sx: {
                borderRadius: isSmall ? '5px' : '8px',
                textTransform: 'none',
                height: isSmall ? 'auto' : '48px',
                width: isSmall ? '42px' : 'auto',
                padding: isSmall ? '5px' : '12px',
                fontSize: 'medium',
                '&:hover': {
                    backgroundColor: lighten(theme.palette.primary.main, 0.9),
                    color: theme.palette.primary.main,
                    borderColor: theme.palette.primary.main,
                },
            } },
            Preact.h(Redo, { fontSize: "medium" }))));
};
Component.displayName = 'ActionBarUndoRedo';
